import { render, staticRenderFns } from "./Add3xProjectModal.vue?vue&type=template&id=6fa80e02&scoped=true"
import script from "./Add3xProjectModal.vue?vue&type=script&lang=js"
export * from "./Add3xProjectModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Add3xProjectModal.vue?vue&type=style&index=1&id=6fa80e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa80e02",
  null
  
)

export default component.exports